import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/common.json" with { type: "json" };

/**
 * Locale foundation per `07_UI_UX_SPEC.md` §22: English now, architecture-ready for Bangla.
 * Adding `bn` later is a matter of dropping in `locales/bn/common.json` and registering it below
 * — no component changes required, since every user-facing string goes through `t()`.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
  },
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;
